﻿export function loadExplorer(_insight: Insight, _json: any, interopReference: any): void {
    let insight = {};
    var columns = {};
    if (_insight.columns) {
        if (_insight.columns.x) {
            columns["x"] = _insight.columns.x;
        }
        if (_insight.columns.y) {
            columns["y"] = _insight.columns.y;
        }
        if (_insight.columns.z) {
            columns["z"] = _insight.columns.z;
        }
        if (_insight.columns.color) {
            columns["color"] = _insight.columns.color;
        }
        if (_insight.columns.sort) {
            columns["sort"] = _insight.columns.sort;
        }
        if (_insight.columns.size) {
            columns["size"] = _insight.columns.size;
        }
        if (_insight.columns.uid) {
            columns["uid"] = _insight.columns.uid;
        }
        if (_insight.columns.group) {
            columns["group"] = _insight.columns.group;
        }
        if (_insight.columns.facet) {
            columns["facet"] = _insight.columns.facet;
        }
        if (_insight.columns.facetV) {
            columns["facetV"] = _insight.columns.facetV;
        }
    }
    insight["columns"] = columns;

    var size = {};
    if (_insight.size) {
        if (_insight.size.width) {
            size["width"] = _insight.size.width;
        }
        else {
            size["width"] = 700;
        }
        if (_insight.size.height) {
            size["height"] = _insight.size.height;
        }
        else {
            size["height"] = 700;
        }
    }
    else {
        size["width"] = 700;
        size["height"] = 700;
    }
    insight["size"] = size;

    if (_insight.view) {
        insight["view"] = _insight.view;
    }
    else {
        insight["view"] = '2d';
    }

    if (_insight.chart) {
        insight["chart"] = _insight.chart;
    }
    else {
        insight["chart"] = 'barchartV';
    }

    if (_insight.scheme) {
        insight["scheme"] = _insight.scheme;
    }
    else {
        insight["scheme"] = 'category20';
    }

    if (_insight.facetStyle) {
        insight["facetStyle"] = _insight.facetStyle;
    }
    else {
        insight["facetStyle"] = 'wrap';
    }

    if (_insight.totalStyle) {
        insight["totalStyle"] = _insight.totalStyle;
    }
    else {
        insight["totalStyle"] = 'sum-treemap';
    }

    if (_insight.colorBin) {
        insight["colorBin"] = _insight.colorBin;
    }
    else {
        insight["colorBin"] = 'quantize';
    }

    if (_insight.hideAxes) {
        insight["hideAxes"] = _insight.hideAxes;
    }
    else {
        insight["hideAxes"] = false;
    }

    if (_insight.hideLegend) {
        insight["hideLegend"] = _insight.hideLegend;
    }
    else {
        insight["hideLegend"] = false;
    }

    var data = JSON.parse(_json);

    const embedIframe = document.getElementById('embedIframe');
    embedIframe.onload = () => {
        (embedIframe as any).contentWindow.postMessage({ action: 'load', data, insight }, '*');
    }

    (embedIframe as any).contentWindow.postMessage({ action: 'load', data, insight }, '*');

    window.onmessage = async (e) => {
        //console.log('messaged', e.data);
        if (e.data.request.action == "getInsight")
        {
            await interopReference.invokeMethodAsync("GetInsight", e.data.insight);
        }
    };
}

(window as any).loadExplorer = loadExplorer;

export function getInsight(): void {
    const embedIframe = document.getElementById('embedIframe');
    (embedIframe as any).contentWindow.postMessage({ action: 'getInsight' }, '*');
}

(window as any).getInsight = getInsight;

export function setTheme(dark: boolean): void {
    const embedIframe = document.getElementById('embedIframe');
    (embedIframe as any).contentWindow.postMessage({ action: 'theme', dark }, '*');
}

(window as any).setTheme = setTheme;

export function getSetup(): void {
    const embedIframe = document.getElementById('embedIframe');
    (embedIframe as any).contentWindow.postMessage({ action: 'getSetup' }, '*');
}

(window as any).getSetup = getSetup;